import { render, staticRenderFns } from "./current_milestone.vue?vue&type=template&id=1a9eec58&"
import script from "./current_milestone.vue?vue&type=script&lang=js&"
export * from "./current_milestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports